import { FC } from "react";

import { type StatusIconProps, initializeStatusIconProps } from "mds/utils/images";

export const ChatStatusIcon: FC<StatusIconProps> = (props) => {
  const { statusClassName, ...svgProps } = initializeStatusIconProps(props);
  return (
    <svg {...svgProps}>
      <rect
        className={statusClassName}
        height="6"
        rx="3"
        stroke="none"
        width="6"
        x="9.80005"
        y="0.5"
      />
      <path
        d="M8.69922 1.375C8.85016 1.37527 8.94696 1.53678 8.88574 1.6748C8.63778 2.23255 8.5 2.85026 8.5 3.5C8.5 5.98528 10.5147 8 13 8C13.7117 8 14.3843 7.83356 14.9824 7.53906C15.1215 7.47071 15.291 7.56868 15.291 7.72363V11.333C15.291 11.8523 15.0849 12.3505 14.7178 12.7178C14.3505 13.085 13.8523 13.292 13.333 13.292H4.55176C4.36402 13.2921 4.18352 13.3662 4.05078 13.499L2.58301 14.9668C2.42945 15.1202 2.23341 15.2252 2.02051 15.2676C1.80755 15.3099 1.58634 15.2882 1.38574 15.2051C1.18535 15.1219 1.01413 14.9811 0.893555 14.8008C0.772914 14.6202 0.708036 14.4076 0.708008 14.1904V3.33301C0.708094 2.8138 0.914144 2.31541 1.28125 1.94824C1.64837 1.58112 2.14684 1.37515 2.66602 1.375H8.69922ZM5 8.16699C4.72386 8.16699 4.5 8.39085 4.5 8.66699C4.5 8.94313 4.72386 9.16699 5 9.16699H9.33301C9.60915 9.16699 9.83301 8.94313 9.83301 8.66699C9.83301 8.39085 9.60915 8.16699 9.33301 8.16699H5ZM5 5.5C4.72386 5.5 4.5 5.72386 4.5 6C4.5 6.27614 4.72386 6.5 5 6.5H7C7.27614 6.5 7.5 6.27614 7.5 6C7.5 5.72386 7.27614 5.5 7 5.5H5Z"
        fill="currentColor"
      />
    </svg>
  );
};
